import { Indicator, updateIndicator } from '@shared/hooks/src/useIndicator'
import usePubNub, { Channels } from '@shared/hooks/src/usePubNub'
import { useMe } from '@shared/providers/src/MeProvider'
import { queryClient, setQueryData } from '@shared/providers/src/QueryClientProvider'
import { QK, UserRole } from '@shared/utils'

import useSound from '@hooks/useSound'

export function useUserNotifications() {
  const me = useMe()

  const id = me.id
  const providerId = me.provider?.id

  const playNotificationSound = useSound({
    howlProps: { src: '/sounds/notification2.mp3' },
  })

  usePubNub(`user_${id}`, ({ action, attributes }) => {
    if (action === Channels.NewMessage) {
      return updateIndicator(id, Indicator.UnreadConversationsCount, undefined, { count: attributes.unread_conversations })
    }

    if (action === Channels.UpdateQuarterlyFlowCount) {
      return setQueryData(QK.me(id).details, (prev) => ({
        ...prev,
        pendingFlows: attributes.pending_count,
      }))
    }

    if (action === Channels.ReassignedPatient) {
      if ([UserRole.Pharmacy, UserRole.PharmacyManager].includes(me.role)) {
        queryClient.invalidateQueries({ queryKey: QK.pharmacies.tasks.lists })
        queryClient.invalidateQueries({ queryKey: QK.pharmacies.tasks.details })
      }
      if (me.role === UserRole.Provider && providerId) {
        queryClient.invalidateQueries({ queryKey: QK.tasks.lists })
        queryClient.invalidateQueries({ queryKey: QK.providers.id(providerId).dashboard.labs.lists })
        queryClient.invalidateQueries({ queryKey: QK.providers.id(providerId).dashboard.assessments.lists })
        queryClient.invalidateQueries({ queryKey: QK.providers.id(providerId).dashboard.parTasks.lists })
      }
    }

    if (action === Channels.MentionMessage) {
      playNotificationSound()
      queryClient.invalidateQueries({ queryKey: QK.users.id(id).mentions.lists })
    }
  })
}
